import type { Proforma } from "@/lib/proforma.api";

export type ProformaViewMode = "table" | "grid";
export type ProformaStatusFilter = "all" | Proforma["status"];

export const PROFORMAS_PAGE_GUIDE = [
  "Recherchez ou filtrez les proformas par statut.",
  "Cliquez sur « Nouvelle proforma » pour en créer une.",
];

export const PROFORMAS_PAGE_TIP =
  "Une proforma expire automatiquement 48h après sa création si elle n'est pas transformée en facture.";

export const STATUS_STYLES: Record<Proforma["status"], string> = {
  draft: "border-info-border bg-info-bg text-info-text",
  issued: "border-success-border bg-success-bg text-success-text",
  expired: "border-border bg-surface-subtle text-muted-foreground",
  cancelled: "border-danger-border bg-danger-bg text-danger-text",
};

export const STATUS_LABELS: Record<Proforma["status"], string> = {
  draft: "Valide",
  issued: "Émise",
  expired: "Expirée",
  cancelled: "Annulée",
};
